import client from "./sharedoClient";

const getOne = id => client.get(`api/aspects/ods/organisations/${id}`);

export default {
    getOne
}